import { render } from "./EditPost.vue?vue&type=template&id=2e81edda"
import script from "./EditPost.vue?vue&type=script&lang=js"
export * from "./EditPost.vue?vue&type=script&lang=js"

import "./EditPost.vue?vue&type=style&index=0&id=2e81edda&lang=scss"
script.render = render

export default script